var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { background: "#f7f7f7", padding: "10px" } },
    [
      _c(
        "div",
        {
          staticStyle: { background: "#fff", margin: "-10px -10px 10px -10px" },
        },
        [
          _c("div", { staticClass: "kanban-title" }, [
            _vm._v(
              "安骏物流转运看板(Sinalização de transbordo da AnJun Logística)"
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "search-kan",
              staticStyle: { padding: "20px", "margin-bottom": "10px" },
            },
            [
              _c(
                "el-form",
                { attrs: { size: "small" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "大区Região",
                                "label-width": "90px",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "operationCenter.PleaseSelect"
                                    ),
                                    clearable: "",
                                    filterable: "",
                                    multiple: "",
                                    "collapse-tags": "",
                                  },
                                  on: { change: _vm.selectRegionChange },
                                  model: {
                                    value: _vm.queryForm.regionIdList,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm,
                                        "regionIdList",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.regionIdList",
                                  },
                                },
                                _vm._l(_vm.regionList, function (item) {
                                  return _c("el-option", {
                                    key: item.regionId,
                                    attrs: {
                                      label: item.regionName,
                                      value: item.regionId,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "州Estado",
                                "label-width": "90px",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                    filterable: "",
                                    multiple: "",
                                    "collapse-tags": "",
                                  },
                                  on: { change: _vm.changeSiteList },
                                  model: {
                                    value: _vm.queryForm.stateList,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryForm, "stateList", $$v)
                                    },
                                    expression: "queryForm.stateList",
                                  },
                                },
                                _vm._l(_vm.siteList, function (item) {
                                  return _c("el-option", {
                                    key: item.state,
                                    attrs: {
                                      label: item.state,
                                      value: item.state,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "转运中心HUB",
                                "label-width": "100px",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                    filterable: "",
                                    multiple: "",
                                    "collapse-tags": "",
                                  },
                                  model: {
                                    value: _vm.queryForm.siteIdList,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryForm, "siteIdList", $$v)
                                    },
                                    expression: "queryForm.siteIdList",
                                  },
                                },
                                _vm._l(_vm.transferCenterList, function (item) {
                                  return _c("el-option", {
                                    key: item.siteId,
                                    attrs: {
                                      label: item.siteName,
                                      value: item.siteId,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  icon: "el-icon-search",
                                  size: "small",
                                  type: "primary",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.searchResources(1)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("operationCenter.Procurar")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  icon: "el-icon-refresh-left",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.searchResources(2)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("operationCenter.reset")) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-row",
        { staticStyle: { "font-size": "15px", "margin-bottom": "10px" } },
        [
          _c("el-col", { attrs: { span: 19 } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#fff",
                  padding: "15px",
                  "border-radius": "5px",
                  "margin-right": "10px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-weight": "bold",
                      "margin-bottom": "10px",
                    },
                  },
                  [_vm._v("小件(Pacote Pequeno)")]
                ),
                _c(
                  "div",
                  { staticStyle: { display: "flex", "margin-bottom": "40px" } },
                  [
                    _c(
                      "div",
                      { staticStyle: { width: "260px", "margin-top": "30px" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "border-left": "3px solid #1d6a33",
                              padding: "6px 0 6px 10px",
                              "align-items": "center",
                              background:
                                "linear-gradient(to right, #dfefe3, transparent)",
                              "margin-bottom": "20px",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  flex: "1",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumber(
                                      _vm.backlogData.smallBacklog
                                        .twentyFourReceiptQuantity,
                                      0
                                    )
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "160px",
                                  "font-size": "14px",
                                  "line-height": "14px",
                                },
                              },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#009944" } },
                                    [_vm._v("24")]
                                  ),
                                  _vm._v("小时入库数"),
                                ]),
                                _c("div", [_vm._v("(entradas em 24 horas)")]),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "border-left": "3px solid #e3cb05",
                              padding: "6px 0 6px 10px",
                              "align-items": "center",
                              background:
                                "linear-gradient(to right, #f6edc7, transparent)",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  flex: "1",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumber(
                                      _vm.backlogData.smallBacklog
                                        .twentyFourSendQuantity,
                                      0
                                    )
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "160px",
                                  "font-size": "14px",
                                  "line-height": "14px",
                                },
                              },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#f5c936" } },
                                    [_vm._v("24")]
                                  ),
                                  _vm._v("小时出库数"),
                                ]),
                                _c("div", [_vm._v("(saídas em 24 horas)")]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c("div", { staticStyle: { flex: "1" } }, [
                      _c("div", {
                        staticStyle: { height: "200px", width: "100%" },
                        attrs: { id: "smallCargo" },
                      }),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-weight": "bold",
                      "margin-bottom": "10px",
                    },
                  },
                  [_vm._v("大件(Carga grande)")]
                ),
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c(
                    "div",
                    { staticStyle: { width: "260px", "margin-top": "30px" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "border-left": "3px solid #1d6a33",
                            padding: "6px 0 6px 10px",
                            "align-items": "center",
                            background:
                              "linear-gradient(to right, #dfefe3, transparent)",
                            "margin-bottom": "20px",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { flex: "1", "font-weight": "bold" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNumber(
                                    _vm.backlogData.largeBacklog
                                      .twentyFourReceiptQuantity,
                                    0
                                  )
                                )
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "160px",
                                "font-size": "14px",
                                "line-height": "14px",
                              },
                            },
                            [
                              _c("div", [
                                _c(
                                  "span",
                                  { staticStyle: { color: "#009944" } },
                                  [_vm._v("24")]
                                ),
                                _vm._v("小时入库数"),
                              ]),
                              _c("div", [_vm._v("(entradas em 24 horas)")]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "border-left": "3px solid #e3cb05",
                            padding: "6px 0 6px 10px",
                            "align-items": "center",
                            background:
                              "linear-gradient(to right, #f6edc7, transparent)",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { flex: "1", "font-weight": "bold" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNumber(
                                    _vm.backlogData.largeBacklog
                                      .twentyFourSendQuantity,
                                    0
                                  )
                                )
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "160px",
                                "font-size": "14px",
                                "line-height": "14px",
                              },
                            },
                            [
                              _c("div", [
                                _c(
                                  "span",
                                  { staticStyle: { color: "#f5c936" } },
                                  [_vm._v("24")]
                                ),
                                _vm._v("小时出库数"),
                              ]),
                              _c("div", [_vm._v("(saídas em 24 horas)")]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c("div", { staticStyle: { flex: "1" } }, [
                    _c("div", {
                      staticStyle: { height: "200px", width: "100%" },
                      attrs: { id: "bulkyCargo" },
                    }),
                  ]),
                ]),
              ]
            ),
          ]),
          _c(
            "el-col",
            {
              staticStyle: {
                background: "#fff",
                padding: "15px",
                "border-radius": "5px",
              },
              attrs: { span: 5 },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "font-weight": "bold",
                    "margin-bottom": "25px",
                  },
                },
                [_vm._v("退件(Devolução)")]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    "margin-bottom": "25px",
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "24px", height: "24px" },
                    attrs: {
                      src: require("@/assets/images/daifahuo(24).png"),
                      alt: "",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        flex: "1",
                        "line-height": "18px",
                        "padding-left": "10px",
                      },
                    },
                    [
                      _c("div", { staticStyle: { "font-size": "14px" } }, [
                        _c("span", { staticStyle: { color: "#009944" } }, [
                          _vm._v("24"),
                        ]),
                        _vm._v("小时退件数(Número de devoluções em 24 horas)"),
                      ]),
                      _c("div", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatNumber(
                              _vm.backlogData.returnBacklog
                                .twentyFourReturnQuantity,
                              0
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    "margin-bottom": "25px",
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "24px", height: "24px" },
                    attrs: {
                      src: require("@/assets/images/daifahuo(48).png"),
                      alt: "",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        flex: "1",
                        "line-height": "18px",
                        "padding-left": "10px",
                      },
                    },
                    [
                      _c("div", { staticStyle: { "font-size": "14px" } }, [
                        _c("span", { staticStyle: { color: "#f5c936" } }, [
                          _vm._v("48"),
                        ]),
                        _vm._v("小时退件数(Número de devoluções em 48 horas)"),
                      ]),
                      _c("div", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatNumber(
                              _vm.backlogData.returnBacklog
                                .fortyEightReturnQuantity,
                              0
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                { staticStyle: { "margin-bottom": "25px" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "14px",
                        "margin-bottom": "5px",
                      },
                    },
                    [
                      _vm._v(
                        "24h退件未处理数(Devolução não processada em até 24 horas)"
                      ),
                    ]
                  ),
                  _c("el-progress", {
                    key: _vm.backlogData.returnBacklog.progress24,
                    attrs: {
                      "show-text": false,
                      "stroke-width": 8,
                      percentage: _vm.backlogData.returnBacklog.progress24,
                      color: "#ff4949",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "margin-top": "5px",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.formatNumber(
                            _vm.backlogData.returnBacklog
                              .twentyFourReturnDetentionQuantity,
                            0
                          )
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-bottom": "25px" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "14px",
                        "margin-bottom": "5px",
                      },
                    },
                    [
                      _vm._v(
                        "48h退件未处理数(Devolução não processada em até 48 horas)"
                      ),
                    ]
                  ),
                  _c("el-progress", {
                    key: _vm.backlogData.returnBacklog.progress48,
                    attrs: {
                      "show-text": false,
                      "stroke-width": 8,
                      percentage: _vm.backlogData.returnBacklog.progress48,
                      color: "#ff4949",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "margin-top": "5px",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.formatNumber(
                            _vm.backlogData.returnBacklog
                              .fortyEightReturnDetentionQuantity,
                            0
                          )
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "14px",
                        "margin-bottom": "5px",
                      },
                    },
                    [
                      _vm._v(
                        "48+h退件未处理数(Devolução não processada em até 48+ horas)"
                      ),
                    ]
                  ),
                  _c("el-progress", {
                    attrs: {
                      "show-text": false,
                      "stroke-width": 8,
                      percentage: _vm.progress48add,
                      color: "#ff4949",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "margin-top": "5px",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.formatNumber(
                            _vm.backlogData.returnBacklog
                              .fortyEightReturnDetentionOverQuantity,
                            0
                          )
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._m(0),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { padding: "15px", background: "#fff" } }, [
      _c(
        "div",
        { staticStyle: { "font-weight": "bold", "font-size": "15px" } },
        [_vm._v("各州发货排行(Ranking de Envio por Estado)")]
      ),
      _c("div", {
        staticStyle: { height: "200px", width: "100%" },
        attrs: { id: "ranking" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }